export default "__VITE_ASSET__BPXV2Gpo__"